import React from 'react';
import {Text} from '@albert-io/atomic';
import moment from 'moment';
import PropTypes from 'prop-types';
import './author-dashboard-metrics.scss';

const AuthorDashboardMetricsQuestionDifficulties = ({questionDifficulties}) => {
  return (
    <div className='author-dashboard-metrics__difficulty-stats'>
      <div className='author-dashboard-metrics__difficulty-stats-item u-mar-b_1'>
        <Text color='red'>Difficult</Text>
        <Text color='red'>
          {questionDifficulties.difficult ? questionDifficulties.difficult : 0}
        </Text>
      </div>
      <div className='author-dashboard-metrics__difficulty-stats-item u-mar-b_1'>
        <Text color='green'>Moderate</Text>
        <Text color='green'>
          {questionDifficulties.moderate ? questionDifficulties.moderate : 0}
        </Text>
      </div>
      <div className='author-dashboard-metrics__difficulty-stats-item u-mar-b_1'>
        <Text color='blue'>Easy</Text>
        <Text color='blue'>{questionDifficulties.easy ? questionDifficulties.easy : 0}</Text>
      </div>
    </div>
  );
};

AuthorDashboardMetricsQuestionDifficulties.propTypes = {
  questionDifficulties: PropTypes.shape({
    all: PropTypes.integer,
    difficult: PropTypes.integer,
    easy: PropTypes.integer,
    moderate: PropTypes.integer
  })
};

export default AuthorDashboardMetricsQuestionDifficulties;
